import React, { useState, useEffect } from "react";
import Sidebar from "../components/sidebar";
import { BASE_URL } from "../utils/config";
import { useNavigate } from 'react-router-dom';
import {
  Tabs,
  Tab,
  Box,
  FormControl,
  MenuItem,
  InputLabel,
  Select,
  Button,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DownloadIcon from "@mui/icons-material/Download";
import TelegramWidget from "../components/widget/telegramWidget";
import { ProgressBar } from 'react-loader-spinner';
import PerformanceTable from "../components/performance/performanceTable";

const Performancemonitor = () => {
  const navigate = useNavigate();
  const [tabs, setTabs] = useState([
    { id: "future", label: "Future", data: [], active: true },
    { id: "option", label: "Option", data: [],data1: [], active: false },
    { id: "indexoption", label: "Index Option", data: [], active: false },
    { id: "delivery", label: "Delivery", data: [], active: false },
    { id: "hni", label: "HNI", data: [], active: false },
    { id: "mcx", label: "MCX", data: [], active: false },
    { id: "intraDay", label: "Intra Day", data: [],data1: [], active: false },
    { id: 'nkb', label: 'nkb', data: [] ,previousClose:[],active: false}
  ]);
  const [value, setValue] = useState(0);
  const [selectedTabValue, setSelectedTabValue] = useState("Future");
  const [selectedMonth, setselectedMonth] = useState(new Date().toLocaleString('default', { month: 'long' }));
  const [deliverySelectedValue,setDeliverySelectedValue]=useState(1)
  const [selectedYear, setselectedYear] = useState(new Date().getFullYear());

  const [YearsPresentInTheDatabse, setYearsPresentInTheDatabse] = useState([]);
 
  const [Loading, setLoading] = useState(false);
  const [errorDialog,setErrorDialog]=useState(false);
  const [errorMessage,setErrorMessage]=useState("");
  const [showAlert, setshowAlert] = useState(false);
  const [Alertmessage, setAlertmessage] = useState("");
  const [Role, setRole] = useState("");
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  let count = 0;
  useEffect(() => {
    if (count === 0) {
      getYearsPresentInTheDatabse();
      count += 1;
      const roleType = JSON.parse(localStorage.getItem('roleType'));
      console.log("roletypr", roleType);
      if (roleType === 'SuperAdmin') {
        // fetchDataForAllTabs();
        setRole("SuperAdmin")
      } else if (roleType === 'Supervisor') {
        // fetchDataForAllTabs();
        setRole("Supervisor")
      } else if (roleType === 'User'){
        // fetchDataForAllTabs();
        setRole('User')
      }else {
        setRole('MCXUser')
        handletabSelection("","MCX")
        // setSelectedTabValue("MCX")
      }
    }
  }, [selectedTabValue]);

 
//  this function is used to fetch data all years which is present in DB
  const getYearsPresentInTheDatabse = async () => {
    try {
      await fetch(`${BASE_URL}/getAllyears`, {
        method: "GET",
      })
        .then((response) => response.json())
        .then((res) => {
          if (res.success === true) {
            setYearsPresentInTheDatabse(res.data);
          } else {
            setYearsPresentInTheDatabse([]);
            setErrorMessage(`Error: ${res.message}`);
            setErrorDialog(true)
            setTimeout(() => {
              setErrorDialog(false)
              setErrorMessage("")
              }, 1700);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setErrorMessage(`Error: ${error.message}`);
          setErrorDialog(true)
          setTimeout(() => {
            setErrorDialog(false)
            setErrorMessage("")
            }, 1700);
        });

    } catch (error) {
      console.log("error:", error)
      setErrorMessage(`Error: ${error.message}`);
      setErrorDialog(true)
      setTimeout(() => {
        setErrorDialog(false)
        setErrorMessage("")
        }, 1700);
    }
  };


//  this function is used to change values
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // this function is used to to select tab and get data from api
  const handletabSelection = async (event, type) => {
    try{
    console.log("type form signle click", type);
    setSelectedTabValue(type);
    setTabs([
      { id: "future", label: "Future", data: [], active: true },
      { id: "option", label: "Option", data: [],data1: [], active: false },
      { id: "indexoption", label: "Index Option", data: [], active: false },
      { id: "delivery", label: "Delivery", data: [], active: false },
      { id: "hni", label: "HNI", data: [], active: false },
      { id: "mcx", label: "MCX", data: [], active: false },
      { id: "intraDay", label: "Intra Day", data: [],data1: [], active: false },
    ])

      const id =
      type === "Future"
        ? tabs[0].id
        : type === "Option"
          ? tabs[1].id
          : type === "IndexOption"
            ? tabs[2].id
          : type === "IntraDay"
            ? tabs[6].id
            : type === "Delivery"
              ? tabs[3].id
              : type === "Hni"
                ? tabs[4].id
                : type === "MCX"
                  ? tabs[5].id
                  : undefined;

                  let monthvalue = type === "Delivery" ? deliverySelectedValue :selectedMonth
                       
                
                   let api 
                  if(type === "Delivery"){
                    api = `getAllPerformance/${id}/${monthvalue}/${selectedYear}`
                  }else{
                    if(fromDate && toDate){
                      api = `getAllPerformance/${id}/${fromDate}/${toDate}`
                    }else{
                      setErrorMessage(`Error: Please Select From Data and ToDate`);
                      setErrorDialog(true)
                      setTimeout(() => {
                        setErrorDialog(false)
                        setErrorMessage("")
                        }, 3000);
                    }

                  return
                  
                  }

                  await fetch(`${BASE_URL}/${api}`, {
                    method: "GET",
                  })
      .then((response) => response.json())
      .then((res) => {
        if(id === 'intraDay'){
          console.log("res",res)
          if (res.success === true) {
         
            const updatedTabs = tabs.map((tab) => {
              if (tab.id === id) {
                return { ...tab, data: res.data,data1 :res.data1  }; // Update the matched tab's data
              }
              return tab; 
            });
  
            setTabs(updatedTabs); // Update the state with the new tabs array
          } else {
            console.log("API response was not successful.");
            const updatedTabs = tabs.map((tab) => {
              if (tab.id === id) {
                return { ...tab, data: [],data1 :[] }; // Update the matched tab's data
              }
              return tab; // Return other tabs unchanged
            });
  
            setTabs(updatedTabs); // Update the state with the new tabs array
            setErrorMessage(`Error: ${res.message}`);
            setErrorDialog(true)
            setTimeout(() => {
              setErrorDialog(false)
              setErrorMessage("")
              }, 1700);
          }
        } else if(id === 'option'){
          if (res.success === true) {
            // Assuming 'res.data' contains the new data for the tab
             
            const updatedTabs = tabs.map((tab) => {
              if (tab.id === id) {
                return { ...tab, data: res.data,data1 :res.data1  }; // Update the matched tab's data
              }
              return tab; // Return other tabs unchanged
            });
  
            setTabs(updatedTabs); // Update the state with the new tabs array
          } else {
            console.log("API response was not successful.");
            // Assuming 'res.data' contains the new data for the tab
            const updatedTabs = tabs.map((tab) => {
              if (tab.id === id) {
                return { ...tab, data: res.data,data1 :res.data1 }; // Update the matched tab's data
              }
              return tab; // Return other tabs unchanged
            });
  
            setTabs(updatedTabs); // Update the state with the new tabs array
            setErrorMessage(`Error: ${res.message}`);
            setErrorDialog(true)
            setTimeout(() => {
              setErrorDialog(false)
              setErrorMessage("")
              }, 1700);
          }
        }
        else{

      
        if (res.success === true) {
          // Assuming 'res.data' contains the new data for the tab
          const updatedTabs = tabs.map((tab) => {
            if (tab.id === id) {
              return { ...tab, data: res.data }; // Update the matched tab's data
            }
            return tab; // Return other tabs unchanged
          });

          setTabs(updatedTabs); // Update the state with the new tabs array
        } else {
          console.log("API response was not successful.");
          // Assuming 'res.data' contains the new data for the tab
          const updatedTabs = tabs.map((tab) => {
            if (tab.id === id) {
              return { ...tab, data: res.data }; // Update the matched tab's data
            }
            return tab; // Return other tabs unchanged
          });

          setTabs(updatedTabs); // Update the state with the new tabs array

          setErrorMessage(`Error: ${res.message}`);
          setErrorDialog(true)
          setTimeout(() => {
            setErrorDialog(false)
            setErrorMessage("")
            }, 1700);
        }
      }
      })
      .catch((error) => {
        // Handle errors
        console.error("Error fetching data:", error);
        setErrorMessage(`Error: ${error.message}`);
        setErrorDialog(true)
        setTimeout(() => {
          setErrorDialog(false)
          setErrorMessage("")
          }, 1700);
      });
    
    }catch(error){
      setErrorMessage(`Error: ${error.message}`);
      setErrorDialog(true)
      setTimeout(() => {
        setErrorDialog(false)
        setErrorMessage("")
        }, 1700);
    }
    
  };

  //  this function is used to update performace tab data
  const UpdateTabData = async () => {
try{
    const id =
      selectedTabValue === "Future"
        ? tabs[0].id
        : selectedTabValue === "Option"
          ? tabs[1].id
          : selectedTabValue === "IndexOption"
            ? tabs[2].id
            : selectedTabValue === "Delivery"
              ? tabs[3].id
              : selectedTabValue === "Hni"
                ? tabs[4].id
                : selectedTabValue === "MCX"
                  ? tabs[5].id
                  : undefined;

                  let monthvalue =  selectedTabValue === "Delivery" ? deliverySelectedValue :selectedMonth

                  let api 
                  if(selectedTabValue === "Delivery"){
                    api = `getAllPerformance/${id}/${monthvalue}/${selectedYear}`
                  }else{
                   api = `getAllPerformance/${id}/${fromDate}/${toDate}`
                  }
                  await fetch(`${BASE_URL}/${api}`, {
                    method: "GET",
                  })
      .then((response) => response.json())
      .then((res) => {
        if(id === 'intraDay'){
          if (res.success === true) {
            // Assuming 'res.data' contains the new data for the tab
             
            const updatedTabs = tabs.map((tab) => {
              if (tab.id === id) {
                return { ...tab, data: res.data,data1 :res.data1  }; // Update the matched tab's data
              }
              return tab; // Return other tabs unchanged
            });
  
            setTabs(updatedTabs); // Update the state with the new tabs array
          } else {
            console.log("API response was not successful.");
            // Assuming 'res.data' contains the new data for the tab
            const updatedTabs = tabs.map((tab) => {
              if (tab.id === id) {
                return { ...tab, data: res.data,data1 :res.data1 }; // Update the matched tab's data
              }
              return tab; // Return other tabs unchanged
            });
  
            setTabs(updatedTabs); // Update the state with the new tabs array
            setErrorMessage(`Error: ${res.message}`);
            setErrorDialog(true)
            setTimeout(() => {
              setErrorDialog(false)
              setErrorMessage("")
              }, 1700);
          }
        } else if(id === 'option'){
          if (res.success === true) {
            // Assuming 'res.data' contains the new data for the tab
             
            const updatedTabs = tabs.map((tab) => {
              if (tab.id === id) {
                return { ...tab, data: res.data,data1 :res.data1  }; // Update the matched tab's data
              }
              return tab; // Return other tabs unchanged
            });
  
            setTabs(updatedTabs); // Update the state with the new tabs array
          } else {
            console.log("API response was not successful.");
            // Assuming 'res.data' contains the new data for the tab
            const updatedTabs = tabs.map((tab) => {
              if (tab.id === id) {
                return { ...tab, data: res.data,data1 :res.data1 }; // Update the matched tab's data
              }
              return tab; // Return other tabs unchanged
            });
  
            setTabs(updatedTabs); // Update the state with the new tabs array
            setErrorMessage(`Error: ${res.message}`);
            setErrorDialog(true)
            setTimeout(() => {
              setErrorDialog(false)
              setErrorMessage("")
              }, 1700);
          }
        }
        else{

      
        if (res.success === true) {
          // Assuming 'res.data' contains the new data for the tab
          const updatedTabs = tabs.map((tab) => {
            if (tab.id === id) {
              return { ...tab, data: res.data }; // Update the matched tab's data
            }
            return tab; // Return other tabs unchanged
          });

          setTabs(updatedTabs); // Update the state with the new tabs array
        } else {
          console.log("API response was not successful.");
          // Assuming 'res.data' contains the new data for the tab
          const updatedTabs = tabs.map((tab) => {
            if (tab.id === id) {
              return { ...tab, data: res.data }; // Update the matched tab's data
            }
            return tab; // Return other tabs unchanged
          });

          setTabs(updatedTabs); // Update the state with the new tabs array
          setErrorMessage(`Error: ${res.message}`);
          setErrorDialog(true)
          setTimeout(() => {
            setErrorDialog(false)
            setErrorMessage("")
            }, 1700);
        }
      }
      })
      .catch((error) => {
        // Handle errors
        console.error("Error fetching data:", error);
        setErrorMessage(`Error: ${error.message}`);
        setErrorDialog(true)
        setTimeout(() => {
          setErrorDialog(false)
          setErrorMessage("")
          }, 1700);
      });
    }catch(error){
      setErrorMessage(`Error: ${error.message}`);
      setErrorDialog(true)
      setTimeout(() => {
        setErrorDialog(false)
        setErrorMessage("")
        }, 1700);
    }
  };


  // this function is used to handle change of filters
  const handleFilterChange = async (e, filtertype) => {
    try{
     const selectedDate = e.target.value;
     console.log("filterType",filtertype);
    if(filtertype === "Quater"){
      setDeliverySelectedValue(e.target.value)
    }
    else if (filtertype === "fromDate") {
      setFromDate(selectedDate);
      
        setToDate(''); // Reset To Date if From Date is greater
      
    } else if (filtertype === "toDate") {
      setToDate(selectedDate);
      
    }

    if(filtertype !== "fromDate"){
    const id =
      selectedTabValue === "Future"
        ? tabs[0].id
        : selectedTabValue === "Option"
          ? tabs[1].id
          : selectedTabValue === "IndexOption"
            ? tabs[2].id
            : selectedTabValue === "Delivery"
              ? tabs[3].id
              : selectedTabValue === "Hni"
                ? tabs[4].id
                : selectedTabValue === "MCX"
                ? tabs[5].id
                :selectedTabValue === "IntraDay"
                ?tabs[6].id
                : undefined;

    console.log("selectedYear===================:", selectedYear);
    console.log("selectedMonth===================:", selectedMonth);

    let apiUrl = `${BASE_URL}/getAllPerformance/${id}`;

    if (selectedTabValue === "Delivery") {
      // For Delivery tab, continue to use `monthvalue`
      const monthvalue = filtertype === 'Quater' ? selectedDate : deliverySelectedValue;
      apiUrl += `/${monthvalue}/${filtertype === 'year' ? selectedDate : selectedYear}`;
    } else {
      // For other tabs, pass `fromDate` and `toDate`
      apiUrl += `/${fromDate}/${selectedDate}`;
    }

    await fetch(`${apiUrl}`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((res) => {
        if(id === 'intraDay'){
          if (res.success === true) {
            // Assuming 'res.data' contains the new data for the tab
             
            const updatedTabs = tabs.map((tab) => {
              if (tab.id === id) {
                return { ...tab, data: res.data,data1 :res.data1  }; // Update the matched tab's data
              }
              return tab; // Return other tabs unchanged
            });
  
            setTabs(updatedTabs); // Update the state with the new tabs array
          } else {
            console.log("API response was not successful.");
            // Assuming 'res.data' contains the new data for the tab
            const updatedTabs = tabs.map((tab) => {
              if (tab.id === id) {
                return { ...tab, data: res.data,data1 :res.data1 }; // Update the matched tab's data
              }
              return tab; // Return other tabs unchanged
            });
  
            setTabs(updatedTabs); // Update the state with the new tabs array
            setErrorMessage(`Error: ${res.message}`);
            setErrorDialog(true)
            setTimeout(() => {
              setErrorDialog(false)
              setErrorMessage("")
              }, 1700);
          }
        }
        else if(id === 'option'){
          if (res.success === true) {
            // Assuming 'res.data' contains the new data for the tab
             
            const updatedTabs = tabs.map((tab) => {
              if (tab.id === id) {
                return { ...tab, data: res.data,data1 :res.data1  }; // Update the matched tab's data
              }
              return tab; // Return other tabs unchanged
            });
  
            setTabs(updatedTabs); // Update the state with the new tabs array
          } else {
            console.log("API response was not successful.");
            // Assuming 'res.data' contains the new data for the tab
            const updatedTabs = tabs.map((tab) => {
              if (tab.id === id) {
                return { ...tab, data: res.data,data1 :res.data1 }; // Update the matched tab's data
              }
              return tab; // Return other tabs unchanged
            });
  
            setTabs(updatedTabs); // Update the state with the new tabs array
            setErrorMessage(`Error: ${res.message}`);
            setErrorDialog(true)
            setTimeout(() => {
              setErrorDialog(false)
              setErrorMessage("")
              }, 1700);
          }
        }else{

      
        if (res.success === true) {
          // Assuming 'res.data' contains the new data for the tab
          const updatedTabs = tabs.map((tab) => {
            if (tab.id === id) {
              return { ...tab, data: res.data }; // Update the matched tab's data
            }
            return tab; // Return other tabs unchanged
          });

          setTabs(updatedTabs); // Update the state with the new tabs array
        } else {
          console.log("API response was not successful.");
          // Assuming 'res.data' contains the new data for the tab
          const updatedTabs = tabs.map((tab) => {
            if (tab.id === id) {
              return { ...tab, data: res.data }; // Update the matched tab's data
            }
            return tab; // Return other tabs unchanged
          });

          setTabs(updatedTabs); // Update the state with the new tabs array
          setErrorMessage(`Error: ${res.message}`);
          setErrorDialog(true)
          setTimeout(() => {
            setErrorDialog(false)
            setErrorMessage("")
            }, 1700);
        }
      }
      })
      .catch((error) => {
        // Handle errors
        console.error("Error fetching data:", error);
        setErrorMessage(`Error: ${error.message}`);
        setErrorDialog(true)
        setTimeout(() => {
          setErrorDialog(false)
          setErrorMessage("")
          }, 1700);
      });
    
    }
  }catch(error){
    setErrorMessage(`Error: ${error.message}`);
    setErrorDialog(true)
    setTimeout(() => {
      setErrorDialog(false)
      setErrorMessage("")
      }, 1700);
  }
  };


  //  this function is used to create a excel file
  const exportCSV = () => {
    import("xlsx").then((xlsx) => {
      let worksheet;
      const sheetNames = [];
      const sheets = {};
  
      if (selectedTabValue === "Future") {
        console.log("Future===========");
        worksheet = xlsx.utils.json_to_sheet(tabs[0].data);
        sheetNames.push("Future");
        sheets["Future"] = worksheet;
      } else if (selectedTabValue === "Option") {
        console.log("Option===========");
        worksheet = xlsx.utils.json_to_sheet(tabs[1].data);
        sheetNames.push("Option");
        sheets["Option"] = worksheet;
      } else if (selectedTabValue === "IndexOption") {
        console.log("IndexOption===========");
        worksheet = xlsx.utils.json_to_sheet(tabs[2].data);
        sheetNames.push("IndexOption");
        sheets["IndexOption"] = worksheet;
      } else if (selectedTabValue === "Delivery") {
        console.log("Delivery===========");
        worksheet = xlsx.utils.json_to_sheet(tabs[3].data);
        sheetNames.push("Delivery");
        sheets["Delivery"] = worksheet;
      } else if (selectedTabValue === "Hni") {
        console.log("Hni===========", tabs[4].data);
        console.log("Hni===========", typeof tabs[4].data);
        worksheet = xlsx.utils.json_to_sheet(tabs[4].data);
        sheetNames.push("Hni");
        sheets["Hni"] = worksheet;
      } else if (selectedTabValue === "MCX") {
        console.log("MCX===========", tabs[5].data);
        console.log("MCX===========", typeof tabs[5].data);
        worksheet = xlsx.utils.json_to_sheet(tabs[5].data);
        sheetNames.push("MCX");
        sheets["MCX"] = worksheet;
      } else if (selectedTabValue === "IntraDay") {
        console.log("IntraDay===========", tabs[6].data);
        console.log("IntraDay===========", typeof tabs[6].data);
        const intradayOptionSheet = xlsx.utils.json_to_sheet(tabs[6].data);
        const intradayBTSTSheet = xlsx.utils.json_to_sheet(tabs[6].data1);
        sheetNames.push("IntraDay_Option", "IntraDay_BTST");
        sheets["IntraDay_Option"] = intradayOptionSheet;
        sheets["IntraDay_BTST"] = intradayBTSTSheet;
      } else {
        console.log("not matched any of the tab data");
      }
  
      const workbook = { Sheets: sheets, SheetNames: sheetNames };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
  
      saveAsExcelFile(excelBuffer, "Performance_Monitor");
    }).catch(error => {
      console.error("Error importing xlsx library:", error);
    });
  };
  


  //  this function is used to save performace file as a pdf
  
  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        const date = new Date();

        // Extract date components
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");

        // Extract time components
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const seconds = date.getSeconds().toString().padStart(2, "0");

        // Combine date and time components
        const dateTime = `${year}-${month}-${day}_${hours}:${minutes}:${seconds}`;

        module.default.saveAs(
          data,
          fileName + "_export_" + dateTime + EXCEL_EXTENSION
        );
      }
    });
  };

  //  this function is used to send performance pdf to telegram group
  const SendToTelegram = () => {

    setLoading(true);
    let datatosend = selectedTabValue === "Future"
      ? tabs[0].data
      : selectedTabValue === "Option"
        ? tabs[1].data
        : selectedTabValue === "IndexOption"
          ? tabs[2].data
          : selectedTabValue === "Delivery"
            ? tabs[3].data
            : selectedTabValue === "Hni"
              ? tabs[4].data
              : selectedTabValue === "MCX"
                ? tabs[5].data
               
              : selectedTabValue === "IntraDay"
                ? tabs[6].data
                : undefined;


      let data1 =  selectedTabValue === "IntraDay" ?tabs[6].data1:selectedTabValue === "Option" ?tabs[1].data1:[]
            
     let month = selectedTabValue === "delivery"?deliverySelectedValue:selectedMonth

    let data = JSON.stringify({ data: datatosend,data1:data1, TabValue: selectedTabValue, Month: month, Year: selectedYear });
    // console.log("body", data);
    let loginuser = JSON.parse(localStorage.getItem("loginData"));
    fetch(`${BASE_URL}/sendPerformanceDataTotelegram`, {
      method: 'POST',
      body: data,
      headers: {
        'Content-Type': 'application/json',
         'Authorization': `Bearer ${loginuser.token}`
      },
    }).then(response => response.json())
      .then(res => {
        console.log(res);

        if (res.success === true) {
          setLoading(false);
          setAlertmessage(`${res.message}`)
          console.log("pdf sent to telegram");
          setshowAlert(true)
          setTimeout(() => {
            setshowAlert(false)
          }, 3000);
        }
        else if(res.status === 403){ 
          setTimeout(()=>{
            localStorage.clear()
             navigate('/login')
          },3000) 
        }
        else if(res.status === 401){
          setTimeout(()=>{
            localStorage.clear()
             navigate('/login')
          },3000) 
        }
        else {
          setLoading(false);
          setAlertmessage(`${res.message}`)
          console.log("error throguh by API");
          setshowAlert(true)
          setTimeout(() => {
            setshowAlert(false)
          }, 3000);
        }
      })
      .catch(error => {
        setLoading(false);
        setAlertmessage(`${error}`)
        setshowAlert(true)
        setTimeout(() => {
          setshowAlert(false)
        }, 3000);
        console.error('Error fetching data:', error);
      });
  };


  //  this function is used to removeitem  from array
  const removeItemFormArray = async(item,tab,record) =>{
   console.log("itme to remove",item,tab,record);
   
 
   if (tab === "MCX") {
   console.log("tab",tab)
    const updatedData = tabs[5].data.filter((row) => row !== item);
    console.log("updatedData",updatedData)
    setTabs((prevTabs) => {
      const updatedTabs = [...prevTabs];
      updatedTabs[5].data = updatedData; // Update the data for the first tab
      return updatedTabs;
    });
  
  } else if(tab === "Future") {
    console.log("tab",tab)
    const updatedData = tabs[0].data.filter((row) => row !== item);
    console.log("updatedData",updatedData)
    setTabs((prevTabs) => {
      const updatedTabs = [...prevTabs];
      updatedTabs[0].data = updatedData; // Update the data for the first tab
      return updatedTabs;
    });
  }
  else if(tab === "Option") {
    console.log("tab",tab)
    const updatedData = tabs[1].data.filter((row) => row !== item);
    console.log("updatedData",updatedData)
    setTabs((prevTabs) => {
      const updatedTabs = [...prevTabs];
      updatedTabs[1].data = updatedData; // Update the data for the first tab
      return updatedTabs;
    });
  }
  else if(tab === "IntraDay") {
    console.log("tab",tab)
    if(record == 0){
    const updatedData = tabs[6].data.filter((row) => row !== item);
    console.log("updatedData",updatedData)
    setTabs((prevTabs) => {
      const updatedTabs = [...prevTabs];
      updatedTabs[6].data = updatedData; // Update the data for the first tab
      return updatedTabs;
    })
  }else{
    const updatedData = tabs[6].data1.filter((row) => row !== item);
    console.log("updatedData",updatedData)
    setTabs((prevTabs) => {
      const updatedTabs = [...prevTabs];
      updatedTabs[6].data1 = updatedData; // Update the data for the first tab
      return updatedTabs;
    })
    }
  }
  else if(tab === "Delivery") {
    console.log("tab",tab)
    const updatedData = tabs[3].data.filter((row) => row !== item);
    console.log("updatedData",updatedData)
    setTabs((prevTabs) => {
      const updatedTabs = [...prevTabs];
      updatedTabs[3].data = updatedData; // Update the data for the first tab
      return updatedTabs;
    });
  }
  else if(tab === "Hni") {
    console.log("tab",tab)
    const updatedData = tabs[4].data.filter((row) => row !== item);
    console.log("updatedData",updatedData)
    setTabs((prevTabs) => {
      const updatedTabs = [...prevTabs];
      updatedTabs[4].data = updatedData; // Update the data for the first tab
      return updatedTabs;
    });
  }

  }





  return (
    <div>
      <Sidebar />
      <div className="performance-monitor">
        <h2 style={{ textAlign: "center" }}>Performance Monitor</h2>
        <div className="container">
          <div className="tabs-box"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "15px",
            }}
          >
            <Box sx={{ minWidth: '62%' }}>
              
            {Role ==="MCXUser"?
            <Tabs
                onChange={handleChange}
                value={value}
                aria-label="Tabs where each tab needs to be selected manually"
              >
                <Tab
                  label="MCX"
                  onClick={(e) => {
                    handletabSelection(e, "MCX");
                  }}
                   iconPosition="top"
                /> 
            </Tabs>: 
            <Tabs
                onChange={handleChange}
                value={value}
                aria-label="Tabs where each tab needs to be selected manually"
              >
                <Tab
                  label="Future"
                  onClick={(e) => {
                    handletabSelection(e, "Future");
                  }}
                  iconPosition="top"
                />
                <Tab
                  label="Option"
                  onClick={(e) => {
                    handletabSelection(e, "Option");
                  }}
                   iconPosition="top"
                />
                
                 <Tab
                  label="Intra Day"
                  onClick={(e) => {
                    handletabSelection(e, "IntraDay");
                  }}
                   iconPosition="top"
                />
                <Tab
                  label="Delivery"
                  onClick={(e) => {
                    handletabSelection(e, "Delivery");
                  }}
                  iconPosition="top"
                />
                <Tab
                  label="Hni"
                  onClick={(e) => {
                    handletabSelection(e, "Hni");
                  }}
                   iconPosition="top"
                />
                <Tab
                  label="MCX"
                  onClick={(e) => {
                    handletabSelection(e, "MCX");
                  }}
                   iconPosition="top"
                /> 
            </Tabs>}
            </Box>
         
          { selectedTabValue === "Delivery" ? (
            <>
              <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Qtr</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={deliverySelectedValue}
                    label="Filter"
                    onChange={(e) => {
                      // setselectedMonth(e.target.value);
                      handleFilterChange(e, "Quater");
                    }}
                  >
                   
                      <MenuItem key="1" value={1}>Qtr 1</MenuItem>
                      <MenuItem key="2" value={2}>Qtr 2</MenuItem>
                      <MenuItem key="3" value={3}>Qtr 3</MenuItem>
                      <MenuItem key="4" value={4}>Qtr 4</MenuItem>
                    
                  </Select>
                </FormControl>
              </Box>
              <Box sx={{ minWidth: 120 }} style={{ marginLeft: '10px' }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Year</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={selectedYear}
                    label="Filter"
                    onChange={(e) => {
                      // setselectedYear(e.target.value)
                      handleFilterChange(e, "year");
                    }}
                  >
                    {YearsPresentInTheDatabse.map((item, index) => (
                      <MenuItem key={index} value={item.year}>{item.year}</MenuItem>
                    ))}
  
                  </Select>
                </FormControl>
              </Box>
            </>
            ):(
            <>
                <Box sx={{ minWidth: 155 }}>
        <FormControl fullWidth>
          <label
            style={{width:"100% "}} id="from-date-label">From Date</label>
          <input
          
          style={{width:"100% "}}
            type="date"
            id="from-date"
            value={fromDate}
            onChange={(e) => handleFilterChange(e, "fromDate")}
          />
        </FormControl>
      </Box>

      <Box sx={{ minWidth: 155 }} style={{ marginLeft: '10px' }}>
        <FormControl fullWidth>
          <label 
            style={{width:"100% "}} id="to-date-label">To Date</label>
          <input
            style={{width:"100% "}}
            type="date"
            id="to-date"
            value={toDate}
            onChange={(e) => handleFilterChange(e, "toDate")}
            min={fromDate} // Ensure "To Date" cannot be earlier than "From Date"
            disabled={!fromDate} // Disable if "From Date" isn't selected
          />
        </FormControl>
      </Box>
            </>
            )
            }

          
          </div>
      

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "15px",
              width: "100%",
            }}
          >
            {selectedTabValue === "Future" ? (
              <PerformanceTable Record={tabs[0].data} selectedTab={selectedTabValue} UpdateTabData={UpdateTabData} RemoveItem={removeItemFormArray} />
            ) : selectedTabValue === "Option" ? (
              <PerformanceTable Record={tabs[1].data} Record1={tabs[1].data1} selectedTab={selectedTabValue} UpdateTabData={UpdateTabData} RemoveItem={removeItemFormArray}/>
            ) : selectedTabValue === "IndexOption" ? (
              <PerformanceTable Record={tabs[2].data} selectedTab={selectedTabValue} UpdateTabData={UpdateTabData} RemoveItem={removeItemFormArray}/>
            ) : selectedTabValue === "Delivery" ? (
              <PerformanceTable Record={tabs[3].data} selectedTab={selectedTabValue} UpdateTabData={UpdateTabData} RemoveItem={removeItemFormArray}/>
            ) : selectedTabValue === "Hni" ? (
              <PerformanceTable Record={tabs[4].data} selectedTab={selectedTabValue} UpdateTabData={UpdateTabData} RemoveItem={removeItemFormArray}/>
            ) : selectedTabValue === "MCX" ? (
              <PerformanceTable Record={tabs[5].data} selectedTab={selectedTabValue} UpdateTabData={UpdateTabData} RemoveItem={removeItemFormArray}/>
            ) : selectedTabValue === "IntraDay" ? (
              <PerformanceTable Record={tabs[6].data} Record1={tabs[6].data1} selectedTab={selectedTabValue} UpdateTabData={UpdateTabData} RemoveItem={removeItemFormArray}/>
            ) : null}
          </div>
        </div>
        <div
          className="container"
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "end",
            paddingRight: "15px",
            paddingBottom: "50px",
            marginTop: "30px",
          }}
        >
          <span>
            <Button
              variant="contained"
              onClick={exportCSV}
              className="btn-export"
              endIcon={<DownloadIcon />}
            >
              Export to Excel
            </Button>
          </span>
          <span>
            <Button
              variant="contained"
              onClick={SendToTelegram}
              style={{ marginLeft: "15px" }}
              className="btn-export"
            >
              <i className="pi pi-send "></i>&nbsp; Send To Telegram
            </Button>
          </span>
        </div>

        <TelegramWidget/>
      </div>
      <Dialog
        open={showAlert}
        onClose={() => { setshowAlert(false) }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <p style={{ color: "green", padding: '10px 30px 10px 30px', margin: 0 }}>{Alertmessage}</p>
      </Dialog>

      <Dialog
        open={Loading}
        onClose={() => { setLoading(false) }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            backgroundColor: 'transparent', // Set the background color to transparent
            boxShadow: 'none', // Optional: remove the shadow if desired
            overflow: 'hidden', // To ensure the dialog's paper doesn't exceed its custom content
          },
        }}
      >
        <div style={{ padding: '50px' }}>
          <ProgressBar
            visible={true}
            height="80"
            width="80"
            color="#23499E"
            barColor="#23499E"
            borderColor="#000000"
            ariaLabel="progress-bar-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div>
      </Dialog>


        {/*Error Message Dialog */}
                  <Dialog
              open={errorDialog}
              onClose={()=>{setErrorDialog(false)}}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle  id="alert-dialog-title">
              <h4 style={{ color: "red" }}>Failure</h4>
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                 
                       
                  {errorMessage}
                   
                
                </DialogContentText>
              </DialogContent>
             
                  </Dialog>

    </div>
  );
};

export default Performancemonitor;

